<template>
    <div>
        <a-card type="inner" size="small">
            <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" v-bind="layout">
                <a-form-model-item has-feedback label="Password Lama" prop="current_password">
                    <a-input v-model="ruleForm.current_password" type="password" autocomplete="off" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="Password Baru" prop="password">
                    <a-input v-model="ruleForm.password" type="password" autocomplete="off" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="Ulangi Password" prop="password_confirmation">
                    <a-input v-model="ruleForm.password_confirmation" type="password" autocomplete="off" />
                </a-form-model-item>
                <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                    <a-button type="primary" @click="submitForm('ruleForm')">
                        Submit
                    </a-button>
                    <a-button style="margin-left: 10px" @click="handleClose">
                        Tutup
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-card>
    </div>
</template>

<script>
export default {
    props: {
        user_info: {
            type: Object
        }
    },
    data() {
        let validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Masukkan password'));
            } else {
                if (this.ruleForm.password_confirmation !== '') {
                    this.$refs.ruleForm.validateField('password_confirmation');
                }
                callback();
            }
        };
        let validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Masukkan password lagi'));
            } else if (value !== this.ruleForm.password) {
                callback(new Error("Password tidak sama!"));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                password: '',
                password_confirmation: '',
                current_password: ''
            },
            rules: {
                password: [{ validator: validatePass, trigger: 'change' }],
                password_confirmation: [{ validator: validatePass2, trigger: 'change' }],
            },
            layout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 14 },
            },
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.processing = true;

                    let promise;

                    promise = this.$http.post(
                        this.routeUri('api.setting.profile.update', {user_hash: this.user_info.hash}),
                        this.ruleForm
                    );

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false));
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 2000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        handleClose() {
            this.$emit("handleClose", false);
        }
    },
}
</script>
